module.exports = __webpack_public_path__ + "img/chat.1d8bdce1.svg";